@for (position of visiblePositions(); track position) {
  <div class="pointer-events-none fixed z-50" [class]="getPositionClasses(position)">
    <div
      class="pointer-events-auto relative w-[456px] max-w-[calc(100vw-2rem)] transition-all duration-500 ease-in-out"
      [class.flex]="getHoverSignal(position)()"
      [class.flex-col]="getHoverSignal(position)()"
      [class.gap-2]="getHoverSignal(position)()"
      [style.height]="getContainerHeight(position)"
      [style.transform-origin]="getTransformOrigin(position)"
      (mouseenter)="onMouseEnter(position)"
      (mouseleave)="onMouseLeave(position)">
      @for (toast of getToastsForPosition(position); track trackByToastId($index, toast)) {
        <wally-toast-item
          [toast]="toast"
          [visualIndex]="getVisualIndex(toast, position)"
          [totalVisible]="getToastsForPosition(position).length"
          [isHovered]="getHoverSignal(position)()" />
      }
    </div>
  </div>
}
